
export default {
  admin_sistema:null,
  admin:null,
  cidadao:false,
  tipo: 0,
  grupo: 0,
  id:0,
  departamento:0, 
}
